import styled, { css } from 'styled-components';

import {
  TAB_COLOR,
  TAB_LINK_ACTIVE_BORDER_BOTTOM,
  TAB_LINK_BORDER_BOTTOM,
  TAB_LINK_FOCUS_BORDER_BOTTOM,
  WRAPPER_BACKGROUND,
  WRAPPER_BORDER_BOTTOM,
  WRAPPER_BOX_SHADOW,
  WRAPPER_MARGIN,
} from './constants';

const commonWrapperStyles = css`
  display: flex;
  flex-direction: row;

  overflow-x: scroll;
  overflow-y: hidden;
  padding: 0;
  width: 100%;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }

  ${Styles.desktop} {
    display: none;
  }
`;

export const Wrapper = styled.div`
  ${commonWrapperStyles};

  background: ${WRAPPER_BACKGROUND};
  box-shadow: ${WRAPPER_BOX_SHADOW};
  border-block-end: ${WRAPPER_BORDER_BOTTOM};
  height: 3rem;
  margin-block-end: ${WRAPPER_MARGIN};

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }

  ${Styles.desktop} {
    display: none;
  }
`;

export const NewTabWrapper = styled.div`
  ${commonWrapperStyles};

  align-items: center;
  height: 3.5rem;

  background: ${Styles.color.white};
  position: sticky;
  inset-block-start: -1px;
  z-index: ${Styles.zIndex.top};
`;

const commonTabItemStyles = css`
  text-decoration: none;
  font-family: ${Styles.fontFamily.base};
  text-align: center;
  text-transform: none;
  letter-spacing: normal;
  max-width: 100%;
  white-space: nowrap;
  outline: 0;
  cursor: pointer;
  margin: 0;
  font-size: 1rem;
  height: 100%;
  font-weight: normal;
`;

export const TabItem = styled.div<{ active?: boolean }>`
  ${commonTabItemStyles};

  border-block-end: ${TAB_LINK_BORDER_BOTTOM};
  color: ${TAB_COLOR};
  padding: 0.5rem;

  ${({ active }) =>
    active &&
    css`
      border-block-end: ${TAB_LINK_ACTIVE_BORDER_BOTTOM};
      color: ${Styles.color.primary};
    `}

  &:focus {
    border-block-end: ${TAB_LINK_FOCUS_BORDER_BOTTOM};
    transform: none;
  }
`;

export const NewTabItem = styled.div<{ active?: boolean }>`
  ${commonTabItemStyles};

  align-items: center;
  display: flex;

  padding-block: 0;
  padding-inline: 0.75rem;

  border-block-end: 3px solid;
  color: ${({ active }) => (active ? Styles.color.primary : TAB_COLOR)};
  border-block-end-color: ${({ active }) => (active ? Styles.color.primary : '#0000001A')};
  font-family: ${({ active }) => (active ? Styles.fontFamily.base : Styles.fontFamily.body)};
`;
